__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-3b72066b/_next/";